/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerCompanyComplianceStatus = {
    Compliant: 'COMPLIANT',
    Pending: 'PENDING',
    NotCompliant: 'NOT_COMPLIANT',
    Expired: 'EXPIRED'
} as const;
export type FreelancerCompanyComplianceStatus = typeof FreelancerCompanyComplianceStatus[keyof typeof FreelancerCompanyComplianceStatus];


export function instanceOfFreelancerCompanyComplianceStatus(value: any): boolean {
    for (const key in FreelancerCompanyComplianceStatus) {
        if (Object.prototype.hasOwnProperty.call(FreelancerCompanyComplianceStatus, key)) {
            // @ts-ignore
            if (FreelancerCompanyComplianceStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerCompanyComplianceStatusFromJSON(json: any): FreelancerCompanyComplianceStatus {
    return FreelancerCompanyComplianceStatusFromJSONTyped(json, false);
}

export function FreelancerCompanyComplianceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyComplianceStatus {
    return json as FreelancerCompanyComplianceStatus;
}

export function FreelancerCompanyComplianceStatusToJSON(value?: FreelancerCompanyComplianceStatus | null): any {
    return value as any;
}

